const getTokenExpiration = () => {
  const token = localStorage.getItem('token');

  if (token) {
    const parsedToken = JSON.parse(token);
    if (!parsedToken.issued_at) {
      return null;
    }
    return new Date(parsedToken.expires_in * 1000 + parsedToken.issued_at);
  }

  return null;
};

const needsRefresh = (localToken) => {
  if (!localToken.issued_at) {
    return true;
  }
  const accessTokenExpiresIn = new Date(localToken.issued_at + localToken.expires_in * 1000);
  const now = new Date(Date.now() + 20000);

  return accessTokenExpiresIn <= now; //Token expired
};

const getToken = () => {
  const localToken = localStorage.getItem('token');
  return localToken ? JSON.parse(localToken) : null;
};

const hasPermission = (requiredPermission) => {
  const token = getToken();
  if (!token) {
    return false;
  }
  const userPermissionsArray = token.user_permissions;
  if (!userPermissionsArray || !userPermissionsArray.length) {
    return false;
  }
  const foundPermission = userPermissionsArray.find((permissionObject) => {
    return permissionObject.is_enabled && permissionObject.permission === requiredPermission;
  });
  return !!foundPermission;
};

const removeToken = () => {
  localStorage.removeItem('token');
};

const setToken = (value) => {
  localStorage.setItem('token', JSON.stringify(Object.assign(value, { issued_at: Date.now() })));
};

const utils = {
  getToken,
  setToken,
  getTokenExpiration,
  needsRefresh,
  removeToken,
  hasPermission,
};

export default utils;
